/* eslint-disable @next/next/no-img-element */
import React from 'react';

import WidgetsCard from '@/components/ui/WidgetsCard';

import GalleryItem, { IGalleryItemProps } from './GalleryItem';

export interface IProjectGalleryProps {
  title: string;
  galleryItems: IGalleryItemProps[];
  className?: string;
}

const ProjectGallery: React.FC<IProjectGalleryProps> = ({
  className,
  galleryItems,
  title,
}) => {
  return (
    <WidgetsCard title={title} className={className}>
      {galleryItems.map((galleryItem) => (
        <GalleryItem key={galleryItem.title} {...galleryItem} />
      ))}
    </WidgetsCard>
  );
};

export default ProjectGallery;
